/**
 * The trace's stamp preview — what the order-property stamper would write to
 * UltraCart if the conversation ended at this reply.
 *
 * The three property names are display COPIES of `ORDER_PROPERTY_NAMES` in
 * `@sophie/determinism`: the web bundle cannot import that package's runtime
 * values (CJS through Rollup), the same constraint that pinned
 * `lib/eval-review/filing.ts`. `stamp.test.ts` pins them — vitest CAN import
 * the package — so a rename there fails a test here instead of silently
 * rendering "nothing" for a property that was in fact planned.
 */

export const STAMP_PROPERTY_NAMES = [
  'Return reasons - no refund',
  'Save Initiated',
  'Saving Source',
] as const;

export interface StampPreview {
  properties: Record<string, string>;
  tags: string[];
  skipped: string | null;
}

/** Reads `facts.stamp` defensively; null hides the section (older runs). */
export function readStampPreview(facts: unknown): StampPreview | null {
  const stamp = (facts as Record<string, unknown> | null)?.stamp;
  if (typeof stamp !== 'object' || stamp === null) return null;
  const record = stamp as Record<string, unknown>;
  const properties =
    typeof record.properties === 'object' && record.properties !== null
      ? (record.properties as Record<string, string>)
      : {};
  return {
    properties,
    tags: Array.isArray(record.tags) ? (record.tags as string[]) : [],
    skipped: typeof record.skipped === 'string' ? record.skipped : null,
  };
}
